module.exports = __webpack_public_path__ + "img/mobile/BetBar/Home_button@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar/Home_button@2x.png
// module id = 594
// module chunks = 0